import {STORE_BRANCH_REQUEST, STORE_BRANCH_SUCCESS, STORE_BRANCH_FAILURE} from '../actions';
import {UPDATE_BRANCH_REQUEST, UPDATE_BRANCH_SUCCESS, UPDATE_BRANCH_FAILURE} from '../actions';

export const BRANCH_INITIAL_STATE = {
    id: null,
    isFetching: false,
    error: null,
    branch_name: '',
    address_line_1: '',
    address_line_2: '',
    address_line_3: '',
    post_code: '',
    contact_name: '',
    phone_number: '',
    email: ''
};

const branchReducers = {
    [STORE_BRANCH_REQUEST]: (state, action) => {
        return {...state, ...action, isFetching: true, error: null, draft: true};
    },
    [STORE_BRANCH_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null}
    },
    [STORE_BRANCH_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [UPDATE_BRANCH_REQUEST]: (state, action) => {
        return {...state, ...action, isFetching: true, error: null};
    },
    [UPDATE_BRANCH_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null}
    },
    [UPDATE_BRANCH_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    }
};

export default function branch(state = BRANCH_INITIAL_STATE, action) {
    let reducer = branchReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/branch.js